<div class="backdrop" *ngIf="isLoading" role="status" aria-live="polite">
  <div class="spinner-container">
    <div class="spinner-page" aria-hidden="true"></div>
    <span class="visually-hidden">{{ textShow }}</span>
  </div>
</div>
